import { type UseMutationOptions, type UseMutationResult, useMutation } from '@tanstack/react-query';

import { useQueryStateAppContext } from '@/packages/query-state/shared/context/appContext';

import {
  type TDeleteOfferFromFavoritesRequest,
  type TDeleteOfferFromFavoritesResponse_1,
} from '@/repositories/generated/shared/favorites/v1/delete-offer-from-favorites';

import { type QueryError, getQueryKey } from './internal/config';
import { fetchDeleteOfferFromFavoritesService } from './internal/fetchService';

type DeleteOfferFromFavoritesParameters = TDeleteOfferFromFavoritesRequest;
type DeleteOfferFromFavoritesOptions<TContext> = Omit<
  UseMutationOptions<TDeleteOfferFromFavoritesResponse_1, QueryError, DeleteOfferFromFavoritesParameters, TContext>,
  'mutationKey' | 'mutationFn'
>;

export function useDeleteOfferFromFavoritesMutation<TContext = unknown>(
  options?: DeleteOfferFromFavoritesOptions<TContext>,
): UseMutationResult<TDeleteOfferFromFavoritesResponse_1, QueryError, DeleteOfferFromFavoritesParameters, TContext> {
  const context = useQueryStateAppContext();

  return useMutation<TDeleteOfferFromFavoritesResponse_1, QueryError, DeleteOfferFromFavoritesParameters, TContext>({
    mutationFn: parameters => fetchDeleteOfferFromFavoritesService(context, parameters),
    mutationKey: getQueryKey(),
    ...options,
  });
}
